module.exports = __webpack_public_path__ + "img/fire_center_logo.bb9d8f7d.png";